export enum ROLES {
    ADMINISTRATOR = 0,
        MANAGERONE,
        MANAGERTWO,
        USER

}
